export const ENDPOINT = process.env.REACT_APP_API_ENDPOINT

export const ACTION = {
  CREATE: 'create',
  EDIT: 'edit',
  LIST: 'list',
  DETAIL: 'detail'
}

export const RESPONSE_MESSAGE = {
  SUCCESS: 'บันทึกข้อมูลสำเร็จ',
  FAIL: 'บันทึกข้อมูลไม่สำเร็จ'
}

export const HERO_TYPE = {
  CIRCULAR_BIN: 'CIRCULAR_BIN',
  RECYCLE_SHOP: 'RECYCLE_SHOP',
  SCOOTER: 'SCOOTER',
  DROP_POINT: 'DROP_POINT',
  POSTAL: 'POSTAL',
  FACTORY: 'FACTORY'
}

export const DATE = {
  FORMAT: 'YYYY-MM-DD'
}

export const QUANTITY_OPTIONS = [
  {
    name: 'NO_LIMIT',
    title: 'ไม่กำหนด'
  },
  {
    name: 'UNIT_10',
    title: '> 10 กก.'
  },
  {
    name: 'UNIT_100',
    title: '> 100 กก.'
  },
  {
    name: 'UNIT_1000',
    title: '> 1000 กก.'
  }
]

export const PRODUCT_MANAGEMENT = [
  { name: 'เทกองบนรถ', value: 'เทกองบนรถ' },
  { name: 'อัดแน่นก้อนเล็ก', value: 'อัดแน่นก้อนเล็ก' },
  { name: 'อัดหลวมแนวตั้ง', value: 'อัดหลวมแนวตั้ง' },
  { name: 'อัดใหญ่แนวนอน', value: 'อัดใหญ่แนวนอน' },
  { name: 'อัดเป็นเม็ดจากผง', value: 'อัดเป็นเม็ดจากผง' },
  { name: 'บดย่อย', value: 'บดย่อย' },
  { name: 'บดผง', value: 'บดผง' },
  { name: 'ตัดสั้น', value: 'ตัดสั้น' },
  { name: 'ย่อยด้วยเครื่องสับ', value: 'ย่อยด้วยเครื่องสับ' },
  { name: 'ใส่ถุงบิ๊กแบค', value: 'ใส่ถุงบิ๊กแบค' },
  { name: 'ใส่กระสอบ', value: 'ใส่กระสอบ' },
  { name: 'เรียงบนพาเลท', value: 'เรียงบนพาเลท' },
  {
    name: 'อื่นๆ (ระบุเพิ่มที่เงื่อนไข)',
    value: 'อื่นๆ (ระบุเพิ่มที่เงื่อนไข)'
  }
]

export const TRANSPORTS = [
  { name: 'รถกระบะ', value: 'รถกระบะ' },
  { name: 'รถ 6 ล้อ', value: 'รถ 6 ล้อ' },
  { name: 'รถ 10-12 ล้อ', value: 'รถ 10-12 ล้อ' },
  { name: 'รถพ่วงคอก', value: 'รถพ่วงคอก' },
  { name: 'รถพ่วงพื้นเรียบ', value: 'รถพ่วงพื้นเรียบ' },
  { name: 'รถเทลเลอร์', value: 'รถเทลเลอร์' },
  { name: 'รถที่ยกดั้มพ์ได้', value: 'รถที่ยกดั้มพ์ได้' },
  { name: 'รถคอกที่เปิดข้างได้', value: 'รถคอกที่เปิดข้างได้' },
  { name: 'ใส่ตู้คอนเทนเนอร์เปิดบน', value: 'ใส่ตู้คอนเทนเนอร์เปิดบน' },
  { name: 'ใส่ตู้คอนเทนเนอร์เปิดท้าย', value: 'ใส่ตู้คอนเทนเนอร์เปิดท้าย' },
  { name: 'โรงงานมีรถไปรับ', value: 'โรงงานมีรถไปรับ' }
]

export const EVIDENCES = [
  { name: 'สำเนาบัตรประชาชนผู้ขาย', value: 'สำเนาบัตรประชาชนผู้ขาย' },
  { name: 'ทะเบียนพาณิชย์', value: 'ทะเบียนพาณิชย์' },
  { name: 'ภพ. 20', value: 'ภพ. 20' },
  { name: 'สำเนาบัญชีธนาคาร', value: 'สำเนาบัญชีธนาคาร' },
  { name: 'ทะเบียนโรงงาน รง.4', value: 'ทะเบียนโรงงาน รง.4' },
  { name: 'ใบนำส่งของโรงงาน', value: 'ใบนำส่งของโรงงาน' },
  { name: 'ใบชั่งน้ำหน้า ต้นทาง', value: 'ใบชั่งน้ำหน้า ต้นทาง' },
  { name: 'หลักฐานรถขนส่ง และคนขับ', value: 'หลักฐานรถขนส่ง และคนขับ' }
]

export const PAYMENTS = [
  { name: 'จ่ายล่วงหน้าได้', value: 'จ่ายล่วงหน้าได้' },
  { name: 'เมื่อสินค้าถึงโรงงาน', value: 'เมื่อสินค้าถึงโรงงาน' },
  { name: 'ทันทีหลังลงสินค้า', value: 'ทันทีหลังลงสินค้า' },
  { name: 'หลังได้หลักฐานใบกำกับภาษี', value: 'หลังได้หลักฐานใบกำกับภาษี' },
  { name: 'หลังได้ใบกำกับภาษีตัวจริง', value: 'หลังได้ใบกำกับภาษีตัวจริง' },
  { name: 'ภายใน 7 วัน', value: 'ภายใน 7 วัน' },
  { name: 'ภายใน 14 วัน', value: 'ภายใน 14 วัน' },
  { name: 'ภายใน 30 วัน', value: 'ภายใน 30 วัน' },
  { name: 'ภายใน 45 วัน', value: 'ภายใน 45 วัน' }
]



// WEBPACK FOOTER //
// ./src/utils/constants.js